<ndt-system-active-calls-register-view
   [callState]="callState$ | async"
   [dataSource]="dataSource$ | async"
   [hasNextPage]="hasNextPage$ | async"
   [pagingCallState]="pagingCallState$ | async"
   [totalCount]="totalCount$ | async"
   [name]="entityName"
   [columns]="columns"
   [hangupActiveCallsPrivileges]="hangupActiveCallsPrivileges$ | async"
   [isSystemUser]="isSystemUser$ | async"
   (create)="onCreate()"
   (loadMore)="onLoadMore()"
   (openDialog)="onOpenDialog($event)"
   (hangupActiveCall)="onHangupActiveCall($event)"
   (quickFilterChange)="onQuickFilterChange($event)"
   (orderingOptionsChange)="onOrderingOptionsChange($event)"
   [orderingOptions]="orderingOptions$ | async"
></ndt-system-active-calls-register-view>
